import React from 'react';
import { Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { NavLink } from '../../../../lib/components/link';
import classes from './mobileHeader.css';
import MenuType from '../../../../lib/proptypes/menu.proptypes';
import arrowIcon from '../../../../assets/images/arrow.svg';

const ScrollIndicator = () =>
  (<div className={classes.scrollIndicatorStyle}>
    <img src={arrowIcon} alt="Scroll for additional links" />
  </div>);

const QuickLinkMenuItem = item => {
  if (!item.action && !item.url) {
    // Bail if we don't have the information that we need here
    return null;
  }

  return (
    <NavLink
      key={item.key}
      className={classes.linkText}
      activeClassName={classes.active}
      {...item}
    />
  );
};

const MobileQuickLinks = ({ menu }) =>
  (<div className={classes.quickLinksContainer}>
    <Menu
      secondary
      borderless
      attached="bottom"
      className={classes.quickLinksMenu}
      style={null}
    >
      <Menu.Item className={classes.quickLinksLabel} header>
        Quick Links
      </Menu.Item>
      {!menu.length &&
        <Menu.Item className={classes.linkText}>Loading</Menu.Item>}
      {menu.map(QuickLinkMenuItem)}
    </Menu>
    <ScrollIndicator />
  </div>);
const mapStateToProps = state => ({
  menu: state.nav.quickLinks,
});

MobileQuickLinks.propTypes = {
  menu: MenuType.isRequired,
};

export default connect(mapStateToProps)(MobileQuickLinks);



// WEBPACK FOOTER //
// ./src/app/components/Header/MobileHeader/MobileQuickLinks.js